import { render, staticRenderFns } from "./SecretQuestionForm.vue?vue&type=template&id=f2c00c3a"
import script from "./SecretQuestionForm.vue?vue&type=script&lang=js"
export * from "./SecretQuestionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports